import { Skeleton } from "@/app/components/shadcn/skeleton";

const CartNavigationSkeleton = () => {
  return (
    <>
      {Array.from({ length: 2 }).map((_, i) => (
        <div key={i} className="flex gap-2 p-2">
          <Skeleton className="w-16 h-20 rounded" />
          <div className="flex-1 space-y-2">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-3 w-3/4" />
            <Skeleton className="h-4 w-1/2" />
          </div>
        </div>
      ))}
    </>
  );
};

export default CartNavigationSkeleton;